export const NAV_GROUPS = [
  {
    id: "overview",
    label: "OVERVIEW",
    items: [
      { id: "executive", title: "Boardroom", path: "/executive" },
      { id: "command_center", title: "Command Center", path: "/command-center" },
    ],
  },
  {
    id: "csuite",
    label: "C-SUITE",
    items: [
      { id: "ceo", title: "CEO", path: "/ceo" },
      { id: "cfo", title: "CFO", path: "/cfo" },
      { id: "cmo", title: "CMO", path: "/cmo" },
      { id: "cto", title: "CTO", path: "/cto" },
    ],
  },
  {
    id: "intelligence",
    label: "C-ORE INTELLIGENCE",
    items: [
      { id: "briefing",            title: "Executive Briefing",  path: "/briefing" },
      { id: "trends",              title: "Financial Trends",    path: "/trends" },
      { id: "financial_sync",      title: "Financial Sync",      path: "/financial-sync" },
      { id: "history",             title: "Statement History",   path: "/financial-sync/history" },
      { id: "projectile",          title: "Company Trajectory",  path: "/projectile" },
      { id: "forecasting",         title: "Forecasting",         path: "/forecasting" },
      { id: "alerts",              title: "Smart Alerts",        path: "/alerts" },
      { id: "business_panels",     title: "Business Cockpit",    path: "/business-panels" },
      { id: "benchmarking",        title: "Benchmarking",        path: "/benchmarking" },
      { id: "supplier_verification", title: "Supplier Audit", path: "/supplier-verification" },
    ],
  },
  {
    id: "partners",
    label: "PARTNERS & TOOLS",
    items: [
      // { id: "ca_portal",    title: "CA Portal",     path: "/ca-portal" }, // temporarily hidden
      { id: "advanced_ai",  title: "Advanced Tools",   path: "/advanced-ai" },
      { id: "connect",     title: "C-ORE Connect", path: "/connect" },
      { id: "fund",        title: "C-ORE Fund",    path: "/fund" },
      { id: "expert",      title: "C-ORE Expert",  path: "/expert" },
      { id: "integrations", title: "Integrations",  path: "/integrations" },
      { id: "pricing",      title: "Billing",       path: "/pricing" },
    ],
  },
];

export const ALL_NAV_ITEMS = NAV_GROUPS.flatMap((g) => g.items);

export function findNavItem(pathname) {
  return ALL_NAV_ITEMS.find((i) => pathname === i.path || pathname.startsWith(i.path + "/"));
}
